module.exports = __webpack_public_path__ + "static/img/company5.f5e93b97.png";